import { render, staticRenderFns } from "./DropdownItem.vue?vue&type=template&id=c5516112&"
import script from "./DropdownItem.vue?vue&type=script&lang=js&"
export * from "./DropdownItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c5516112', component.options)
    } else {
      api.reload('c5516112', component.options)
    }
    module.hot.accept("./DropdownItem.vue?vue&type=template&id=c5516112&", function () {
      api.rerender('c5516112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/common/DropdownItem.vue"
export default component.exports